<template>
    <v-card>
        <v-card-title class="white--text" :style="{background: colors().primary1}">
            <div class="headline">Rediger bruker</div>
        </v-card-title>
        <v-card-text class="px-3 pt-3">
            <v-form ref="form">
                <v-text-field v-model="modifiedUser.email" label="brukernavn (e-post)" filled :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="modifiedUser.firstname" label="fornavn" filled :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="modifiedUser.lastname" label="etternavn" filled :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="modifiedUser.mobile" label="mobil" filled :rules="[rules.required]"></v-text-field>

                <!-- <v-checkbox v-model="newPassword" label="nytt passord"></v-checkbox> -->

                <!-- <v-slide-y-transition hide-on-leave>
                    <div v-if="newPassword">
                        <v-text-field v-if="user.id === $store.getters.user.id" v-model="password" label="passord" :type="showPassword ? 'text':'password'" filled :append-icon="showPassword ? 'mdi-eye-off':'mdi-eye'" @click:append="toggleShowPassword" :rules="[rules.required, rules.passwordSanityCheck]"></v-text-field>
                        <v-text-field v-if="user.id === $store.getters.user.id" v-model="passwordCheck" label="gjenta passord" :type="showPassword ? 'text':'password'" filled :rules="[rules.required, rules.passwordSanityCheck]"></v-text-field>
                    </div>
                </v-slide-y-transition> -->

            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel">
                <v-icon left>mdi-close-circle</v-icon>
                avbrytt
            </v-btn>
            <v-btn color="primary" @click="restore">
                <v-icon left>mdi-undo</v-icon>
                angre
            </v-btn>
            <v-btn color="green white--text" @click="save">
                <v-icon left>mdi-pencil</v-icon>
                rediger
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from "axios";
export default {
    props: ["user"],
    data() {
        return {
            modifiedUser: {
                email: undefined,
                firstname: undefined,
                lastname: undefined,
                mobile: undefined
            },
            newPassword: false,
            password: undefined,
            passwordCheck: undefined,
            showPassword: false,
            rules: {
                required: value => !!value || "Påkrevd",
                passwordSanityCheck: value => (value === this.password && value === this.passwordCheck) || "Passord ulike"
            }
        };
    },
    methods: {
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },
        cancel() {
            this.restore();
            this.$emit("cancel");
        },
        restore() {
            this.newPassword = false;
            Object.assign(this.modifiedUser, this.user);
        },
        async save() {
            if (!this.$refs.form.validate()) return;

            await axios.put("/user", { user: this.modifiedUser });
            await this.$store.dispatch("fetchUsersForCurrentCompany");
            this.$emit("saved");
        }
    },
    watch: {
        newPassword: function() {
            if (!this.newPassword) {
                this.password = undefined;
                this.passwordCheck = undefined;
            }
        },
        password: function() {
            this.$refs.form.validate();
        },
        passwordCheck: function() {
            this.$refs.form.validate();
        }
    },
    mounted() {
        Object.assign(this.modifiedUser, this.user);
    }
};
</script>

<style lang="scss">
</style>>